import { Link } from 'react-router-dom';

const TermsPageDe = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Allgemeine Geschäftsbedingungen</h1>

      <div className="prose max-w-none text-gray-600">
        <div className="mb-8">
          <p className="mb-6">
            Willkommen bei Map Prints. Bitte lesen Sie diese Allgemeinen Geschäftsbedingungen sowie unsere <Link to="/privacy" className="text-blue-600 hover:underline">Datenschutzerklärung</Link> sorgfältig durch, bevor Sie unsere Dienste nutzen oder einen Kauf tätigen. Diese Dokumente legen die Regeln und Vorschriften für die Nutzung unserer Website und den Kauf unserer Produkte fest.
          </p>

          <p className="mb-6">
            Mit der Aufgabe einer Bestellung oder der Nutzung unserer Dienste stimmen Sie automatisch diesen Bedingungen zu. Wir empfehlen Ihnen, eine Kopie für Ihre Unterlagen zu speichern oder auszudrucken. Bitte beachten Sie, dass wir diese Bedingungen regelmäßig aktualisieren können, daher empfehlen wir Ihnen, sie vor jedem Kauf zu überprüfen. Die aktuelle Version wurde zuletzt am 27. Januar 2025 aktualisiert und ist nur in Deutsch verfügbar.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">1. Über Map Prints</h2>
          <div className="pl-4">
            <p className="mb-4">Wir sind Map Prints, registriert in Deutschland (Nr. folgt nach Erhalt). Unsere Hauptwebsite ist https://mapprints.de.</p>

            <p className="mb-4">Sie können uns wie folgt erreichen:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>E-Mail: info@mapprints.de oder info.mapprints@gmail.com</li>
              <li>Für offizielle Mitteilungen kontaktieren wir Sie per E-Mail oder Post unter Verwendung Ihrer Bestelldaten</li>
            </ul>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">2. Über unsere Produkte</h2>
          <div className="pl-4">
            <p className="mb-4">Unsere Produkte sind einzigartig und personalisiert. Hier ist, was Sie wissen sollten:</p>

            <ul className="list-disc pl-6 mb-6">
              <li>Produktabbildungen dienen nur zur Veranschaulichung - die tatsächlichen Farben können je nach Bildschirmeinstellungen und verwendeter Papierart variieren</li>
              <li>Jedes Produkt wird individuell nach Ihren Designwünschen für Sie erstellt</li>
              <li>Wir verbessern unsere Produkte kontinuierlich, daher können sich die Spezifikationen ändern</li>
            </ul>

            <p className="mb-4">
              Wir empfehlen Ihnen, die Vorschau Ihres individuellen Produkts vor der Bestellung sorgfältig zu prüfen. Nach der Bestellung können wir keine Rückgaben oder Umtäusche akzeptieren, es sei denn, das Produkt ist fehlerhaft oder beschädigt.
            </p>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">3. Website-Nutzung</h2>
          <div className="pl-4">
            <p className="mb-4">
              Mit der Nutzung unserer Website stimmen Sie unseren Richtlinien zur akzeptablen Nutzung der Website zu. Diese Richtlinien gewährleisten eine sichere und zuverlässige Erfahrung für alle Nutzer. Bitte lesen Sie sie sorgfältig durch, da sie einen wesentlichen Bestandteil dieser Bedingungen darstellen.
            </p>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">4. Daten und Datenschutz</h2>
          <div className="pl-4">
            <p className="mb-4">
              Ihre Privatsphäre ist uns wichtig. Wir behandeln Ihre personenbezogenen Daten gemäß unserer <Link to="/privacy" className="text-blue-600 hover:underline">Datenschutzerklärung</Link>.
            </p>

            <p className="mb-4">Bei der Nutzung unserer Dienste bestätigen Sie, dass:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Sie Eigentümer der uns zur Verfügung gestellten personenbezogenen Daten sind oder die Erlaubnis zu deren Nutzung haben</li>
              <li>Sie das Recht haben, Strava- oder GPX-Daten für die Erstellung von Map Prints Produkten zu verwenden</li>
              <li>Sie verstehen, dass wir nicht für die unbefugte Nutzung von Strava-Daten haften</li>
            </ul>

            <p className="mb-4">
              Bitte stellen Sie sicher, dass Sie die Nutzungsbedingungen von Strava verstehen, bevor Sie deren Daten mit unseren Produkten verwenden.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const TermsPageEn = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>

      <div className="prose max-w-none text-gray-600">
        <div className="mb-8">
          <p className="mb-6">
            Welcome to Map Prints. Before using our services or making a purchase, please read these Terms and Conditions carefully, along with our <Link to="/privacy" className="text-blue-600 hover:underline">Privacy Policy</Link>. These documents outline the rules and regulations for using our website and purchasing our products.
          </p>

          <p className="mb-6">
            By placing an order or using our services, you automatically agree to these terms. We recommend saving or a copy for your received product. Please note that we may update these terms periodically, so we encourage you to review them before each purchase. The current version was last updated on January 27, 2025, and is available only in English.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">1. About Map Prints</h2>
          <div className="pl-4">
            <p className="mb-4">We are Map Prints, registered in Germany (No. coming as soon as received). Our main website is https://mapprints.de.</p>

            <p className="mb-4">You can reach us in the following ways:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Email: info@mapprints.de or info.mapprints@gmail.com</li>
              <li>For official notices, we'll contact you via email or post using your order details</li>
            </ul>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">2. About Our Products</h2>
          <div className="pl-4">
            <p className="mb-4">Our products are unique and personalized. Here's what you should know:</p>

            <ul className="list-disc pl-6 mb-6">
              <li>Product images are for illustration only - actual colors may vary depending on your screen settings and type of paper used for printing</li>
              <li>Each product is bespoke, created specifically for you based on the design you choose</li>
              <li>We continuously improve our products, so specifications may change</li>
            </ul>

            <p className="mb-4">
              We recommend reviewing the preview of your custom product carefully before ordering. Once ordered, we cannot accept returns, refunds or exchanges unless the product is faulty or corrupt.
            </p>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">3. Website Usage</h2>
          <div className="pl-4">
            <p className="mb-4">
              When using our website, you agree to follow our Website Acceptable Use Policy. These guidelines ensure a safe and reliable experience for all users. Please review them carefully as they form an essential part of these terms.
            </p>
          </div>
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">4. Data and Privacy</h2>
          <div className="pl-4">
            <p className="mb-4">
              Your privacy matters to us. We handle your personal information according to our <Link to="/privacy" className="text-blue-600 hover:underline">Privacy Policy</Link>.
            </p>

            <p className="mb-4">When using our services, you confirm that:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>You own or have permission to use any personal data you provide to us</li>
              <li>You have the right to use any Strava data or GPX data for creating Map Prints products on our website</li>
              <li>You understand we're not liable for unauthorized use of Strava data</li>
            </ul>

            <p className="mb-4">
              Please ensure you understand Strava's terms of service before using their data with our products.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { TermsPageDe, TermsPageEn };